import { TournamentTrick } from '../../../types';

export const STARCITY_WINTER_2025_TRICKS: TournamentTrick[] = [
  { id: 'scw1-a', name: '1-A游泳', score: 1 },
  { id: 'scw1-b', name: '1-B小皿', score: 1 },
  { id: 'scw2-a', name: '2-A飞镖', score: 2 },
  { id: 'scw2-b', name: '2-B剑顶滑玉', score: 2 },
  { id: 'scw3-a', name: '3-A飞机-CushionTap收剑', score: 3 },
  { id: 'scw3-b', name: '3-B弹弓止剑', score: 3 },
  { id: 'scw4-a', name: '4-A鸟渡', score: 4 },
  { id: 'scw4-b', name: '4-B逆月交错', score: 4 },
  { id: 'scw5-a', name: '5-A安德鸟渡天中杀', score: 5 },
  { id: 'scw5-b', name: '5-B正反转盘', score: 5 },
];
